import { useMutation } from '@tanstack/react-query';
import { loaders } from './auth.loaders';

export const useGetAuthProvider = () => {
  return useMutation(loaders.getAuthProvider);
};

export const useSigninWithProvider = () => {
  return useMutation(loaders.signinWithProvider);
};

export const useSigninWithMsal = () => {
  return useMutation(loaders.signinWithMsal);
};

export const useChangePassword = () => {
  return useMutation(loaders.changePassword);
};

export const useInitPasswordReset = () => {
  return useMutation(loaders.initPasswordReset);
};

export const useConfirmPasswordReset = () => {
  return useMutation(loaders.confirmPasswordReset);
};

export const useCompleteNewPassword = () => {
  return useMutation(loaders.completeNewPassword);
};

export const useSignout = () => {
  return useMutation(loaders.signout);
};
